import { Link } from '@inertiajs/react'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import type { FeedActor, FeedUserReactionItem } from '@/types'
import { actorInitials, actorName, relativeTime } from './actor_helpers'

type Props = { item: FeedUserReactionItem }

function ActorAvatar({ actor }: { actor: FeedActor }) {
  return (
    <Avatar className="h-10 w-10">
      {actor.avatar_url && <AvatarImage src={actor.avatar_url} alt={actor.username} />}
      <AvatarFallback>{actorInitials(actor)}</AvatarFallback>
    </Avatar>
  )
}

export default function UserReactionFeedItem({ item }: Props) {
  const { actor, emoji, post, created_at } = item
  const profileHref = actor.profile_visible ? `/u/${actor.username}` : null

  return (
    <div className="flex items-start gap-4 rounded-2xl border border-black/5 bg-card p-4 shadow-xs">
      {profileHref ? (
        <Link href={profileHref} className="shrink-0">
          <ActorAvatar actor={actor} />
        </Link>
      ) : (
        <div className="shrink-0">
          <ActorAvatar actor={actor} />
        </div>
      )}

      <div className="min-w-0 flex-1">
        <p className="text-base">
          {profileHref ? (
            <Link href={profileHref} className="font-semibold text-foreground hover:underline">
              {actorName(actor)}
            </Link>
          ) : (
            <span className="font-semibold text-foreground">{actorName(actor)}</span>
          )}
          <span className="text-muted-foreground"> reacted </span>
          <span aria-label={`reacted with ${emoji}`}>{emoji}</span>
          <span className="text-muted-foreground"> to </span>
          <Link
            href={`/o/${post.organization.slug}`}
            className="font-semibold text-foreground hover:underline"
          >
            {post.organization.name}
          </Link>
          <span className="text-muted-foreground">&apos;s post</span>
        </p>
        {post.body_excerpt && (
          <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{post.body_excerpt}</p>
        )}
        <p className="mt-0.5 text-sm text-muted-foreground">{relativeTime(created_at)}</p>
      </div>
    </div>
  )
}
